import { render, staticRenderFns } from "./LeaveCurrentOrderModal.vue?vue&type=template&id=05471e86"
import script from "./LeaveCurrentOrderModal.vue?vue&type=script&lang=js"
export * from "./LeaveCurrentOrderModal.vue?vue&type=script&lang=js"
import style0 from "./LeaveCurrentOrderModal.vue?vue&type=style&index=0&id=05471e86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports